import _ from 'lodash';

export const toFormData = (values) => {
  const formData = new FormData();
  _.mapValues(values, (value, key) => {
    if (value instanceof FileList) {
      _.mapValues(value, (file, index) => {
        formData.append(`${key}${index}`, file);
      });
    } else if (Array.isArray(value) && value.length > 0 && value[0] instanceof File) {
      _.mapValues(value, (file, index) => {
        formData.append(`${key}${index}`, file);
      });
    } else {
      formData.append(key, value);
    }
  });
  formData.append('stringifyValues', JSON.stringify(values));
  return formData;
};

export const getGclFilterInitialValues = (filterPermissions) => {
  const initialValues = {
    calendarFrom: '',
    calendarTo: '',
    modificationFrom: '',
    modificationTo: '',
    obsolete: 0,
    supervisors: [],
    owners: [],
  };

  _.forOwn(filterPermissions, (_value, key) => {
    switch (key) {
      case 'favouriteObligations':
        initialValues[key] = null;
        break;
      case 'state':
      case 'category':
      case 'note':
      case 'probability':
      case 'severity':
      case 'risk':
      case 'nextDate':
      case 'classifiedPlants':
      case 'location':
        initialValues[key] = [];
        break;
      case 'textFilters':
        initialValues.textFilter = '';
        initialValues.textFiltersTypes = [];
        break;
      default:
        initialValues[key] = '';
        break;
    }
  });

  return initialValues;
};

export const getGgclFilterInitialValues = (filterPermissions) => {
  const initialValues = {
    calendarFrom: '',
    calendarTo: '',
    modificationFrom: '',
    modificationTo: '',
  };

  _.forOwn(filterPermissions, (_value, key) => {
    switch (key) {
      case 'favouriteObligations':
        initialValues[key] = null;
        break;
      case 'state':
      case 'category':
      case 'note':
      case 'probability':
      case 'severity':
      case 'risk':
      case 'nextDate':
      case 'location':
      case 'plants':
        initialValues[key] = [];
        break;
      case 'textFilters':
        initialValues.textFilter = '';
        initialValues.textFiltersTypes = [];
        break;
      default:
        initialValues[key] = '';
        break;
    }
  });

  return initialValues;
};

export const getCAFilterInitialValues = () => ({
  dateStampFrom: '',
  dateStampTo: '',
  limitStampFrom: '',
  limitStampTo: '',
  isClosed: 0,
  isOpened: 1,
  hasCloseRequest: 0,
  responsibles: [],
  systems: [],
  plants: [],
  sources: [],
  types: [],
  issuers: [],
  description: '',
  showTaskDependencyGroup: null,
});

export const getResourceManagerFilterInitialValues = () => ({
  id: '',
  resourceHex: '',
  obligationHex: '',
  name: '',
  states: [],
  categories: [],
  plants: [],
  archived: 0,
});

export const getInecoRiskManagerFilterInitialValues = () => ({
  types: [],
  additionalOwners: '',
  //   organizationProcesses: [],
  periods: [],
  strategicGoals: [],
  states: [],
  probabilities: [],
  impacts: [],
  severities: [],
});

export const getDocumentManagerFilterInitialValues = () => ({
  title: '',
  fileName: '',
  hasFile: null,
  description: '',
  dateStampFrom: '',
  dateStampTo: '',
  userBridges: [],
  publicationLocations: [],
  publicationYear: '',
  publicationTypes: [],
  fileTypes: [],
  mainSubjects: [],
  secondarySubjects: [],
  locations: [],
  naturalRegions: [],
  archived: null,
  tags: [],
});

export const getTotalEnergiesRiskRiskFilterInitialValues = () => ({
  code: '',
  description: '',
  causes: '',
  consequences: '',
  riskIDs: [],
  process: [],
  subProcess: [],
  riskType: [],
  state: [],
  impactType: [],
  impactGroupType: [],
  probability: [],
  severity: [],
  priority: [],
  inherentImpact: [],
  hasControls: null,
  active: 0,
});

export const getTotalEnergiesRiskControlFilterInitialValues = () => ({
  code: '',
  name: '',
  description: '',
  responsibleID: [],
  riskIDs: [],
  state: [],
  reviewState: [],
  controlType: [],
  controlClass: [],
  frequency: [],
  controlDocumentation: [],
  controlEfficiency: [],
  active: 0,
});

export const getTotalEnergiesRiskActionPlanFilterInitialValues = () => ({
  code: '',
  description: '',
  process: [],
  responsibleID: [],
  riskIDs: [],
  fromDateStamp: null,
  toDateStamp: null,
  fromStartDateStamp: null,
  toStartDateStamp: null,
  fromEndDateStamp: null,
  toEndDateStamp: null,
  fromModificationDateStamp: null,
  toModificationDateStamp: null,
  state: [],
  reviewState: [],
  active: 0,
});

export const getLogFilterInitialValues = () => ({
  dateFrom: '',
  dateTo: '',
  userBridges: [],
  types: [],
});

export const getEnvironmentalAspectsAssessmentAspectFilterInitialValues = () => ({
  description: '',
  isApply: 0,
});

export const getEnvironmentalAspectsAssessmentInspectionFilterInitialValues = () => ({
  periodicities: [],
  responsibles: [],
  latestEvaluation: [],
});

export const getUserManagementUserAccessCodeFilterInitialValues = () => ({
  code: '',
  dateFrom: '',
  dateTo: '',
  createdDateFrom: '',
  createdDateTo: '',
  isCreated: null,
});

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
